export class OrganisationSearchParams {
  name = "";
}
